const NO_SCROLLBAR_STYLE_CLASS = "ui5-content-native-scrollbars";

const getEffectiveScrollbarStyle = () => document.body.classList.contains(NO_SCROLLBAR_STYLE_CLASS);

export default getEffectiveScrollbarStyle;
